export default "__VITE_ASSET__CF8z_zAQ__"